// Bottom-of-article booking block for blog posts. The mid-body CTAs remain
// BlogCta; this one closes the article with the brand tagline.
import React from 'react'
import Link from 'next/link'
import styled from '@emotion/styled'
import { gsColors as c } from '../../styles/Variables'
import { LinkButton } from '../../styles/Components'
import { mq } from '../../helpers'

const FooterCtaWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin: 40px 0;
  padding: 64px 24px;
  background-color: ${c.cobalt};
  text-align: center;

  ${mq('max', '800px')} {
    margin: 32px 0;
    padding: 40px 16px;
  }

  h2 {
    margin: 0;
    color: ${c.white};
    font-family: Garnett;
    font-size: 32px;
    font-weight: 750;
    line-height: 140%;

    ${mq('max', '800px')} {
      font-size: 24px;
    }
  }

  p {
    max-width: 480px;
    margin: 0 0 8px;
    color: ${c.white};
    font-family: Euclid;
    font-size: 18px;
    line-height: 150%;

    ${mq('max', '800px')} {
      font-size: 16px;
    }
  }
`

const RosyLinkButton = styled(LinkButton)`
  color: ${c.cobalt};
`

/** Render the blog footer booking block with the "Beauty on call" tagline. */
export default function BlogFooterCta() {
  return (
    <FooterCtaWrapper>
      <h2>Beauty on call</h2>
      <p>Certified stylists, makeup artists, and nail pros at your door, anytime, anywhere.</p>
      <Link href='/book' legacyBehavior passHref>
        <RosyLinkButton color={c.salmon}>Book Your Appointment</RosyLinkButton>
      </Link>
    </FooterCtaWrapper>
  )
}
